import React from 'react';

import SiteLink from './SiteLink';

function SiteLinks(props) {
  const {
    links,
    className,
    ...restProps
  } = props;

  return links.map((link, i) => (
    <div
      key={`link${i}`}
      className={className}
    >
      <SiteLink
        {...restProps}
        text={link.text}
        url={link.url}
      />
    </div>
  ));
}

export default SiteLinks;